import { Component, OnInit, ChangeDetectorRef, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CorporateRatingType } from '@sifca-monorepo/ecommerce-generator';
import { isEqual } from 'lodash';
import { Subject, catchError, of, takeUntil } from 'rxjs';
import { InternalProductWithFavoriteStatusType } from '@sifca-monorepo/ecommerce-generator';
import { AppService, AuthService } from '../../../services';

@Component({
  template: '',
})
export class BaseProductInfoTabsComponent implements OnInit, OnDestroy {
  private unsubscribeAll: Subject<any> = new Subject<any>();
  @Input() product: InternalProductWithFavoriteStatusType;
  rating: CorporateRatingType[];
  ratingLength: number;
  isDisabled = true;
  ratingForm: FormGroup;
  internalProductId: string;
  currentUserRating: CorporateRatingType;
  authenticated: boolean;
  isLastRating: boolean;

  constructor(
    protected appService: AppService,
    protected formBuilder: FormBuilder,
    protected authService: AuthService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
    this.authService.authenticated$.subscribe((authenticated: boolean) => {
      this.authenticated = authenticated;
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnInit(): void {
    this.appService.product$.subscribe((res: any) => {
      if (res) {
        this.internalProductId = res.id;
        this.ratingForm = this.formBuilder.group({
          mark: ['', Validators.required],
          comment: [''],
          reviewType: ['OVERALL'],
          product: [this.internalProductId, Validators.required],
        });
        const initialValues = this.ratingForm.value;
        this.ratingForm?.valueChanges.pipe(takeUntil(this.unsubscribeAll))
        .subscribe((values) => {
          this.isDisabled = isEqual(values, initialValues);
        });
        this.appService.corporateRating$.subscribe((corporateRating: CorporateRatingType[]) => {
          if (corporateRating) {
            this.rating = corporateRating;
            this.ratingLength = this.appService.corporateRatingLength;
            this.changeDetectorRef.markForCheck();
          }
        });
        if (this.authenticated) {
          this.appService.getCurrentUserCorporateRatingsByProduct(this.internalProductId)
          .pipe(
            catchError(() => {
              return of(null);
            }),
          )
          .subscribe((result) => {
            this.currentUserRating = result;
            this.ratingForm = this.formBuilder.group({
              mark: [this.currentUserRating ? this.currentUserRating?.mark : '', Validators.required],
              comment: [this.currentUserRating ? this.currentUserRating?.comment : ''],
              reviewType: ['OVERALL'],
              product: [this.internalProductId, Validators.required],
            });
            const initialVal = this.ratingForm.value;
            this.ratingForm?.valueChanges.pipe(takeUntil(this.unsubscribeAll))
            .pipe(
              catchError(() => {
                return of(null);
              }),
            )
            .subscribe((values) => {
              this.isDisabled = isEqual(values, initialVal);
            });
            this.changeDetectorRef.markForCheck();
          });
        }
      }
    });
    this.appService.isLastRating$.subscribe((isLast: boolean) => {
      this.isLastRating = isLast;
    });
  }

  loadRatings() {
    if (!this.isLastRating) {
      this.appService.productsPageIndex$++;
      this.appService.loadMoreCorporateRating(this.internalProductId)
      .pipe(
        catchError(() => {
          return of(null);
        }),
      )
      .subscribe(() => {
        this.changeDetectorRef.markForCheck();
      });
    }
  }

  ngOnDestroy() {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
